<template>
  <v-container fluid grid-list-xl v-if="showDashboard">
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="basil"
          grow
        >
          <v-tab> Motors </v-tab>
          <v-tab> Motors + Accessories </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card
              color="basil"
              flat
              style="float:left; width:100%;"
            >
              <v-card-text>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">WTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorWTDDetailShow = !motorWTDDetailShow">
                      <div class="count greyy"> {{motorCountWTD}} </div>
                      <div class="amount"> ${{motorAmountWTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorWTDDetailShow" v-html="getmotorDetails(motorsWTD)">  </div>
                </v-flex>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">MTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorMTDDetailShow = !motorMTDDetailShow">
                      <div class="count greyy"> {{motorCountMTD}} </div>
                      <div class="amount"> ${{motorAmountMTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorMTDDetailShow" v-html="getmotorDetails(motorsMTD)">  </div>
                </v-flex>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">YTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorYTDDetailShow = !motorYTDDetailShow">
                      <div class="count greyy"> {{motorCountYTD}} </div>
                      <div class="amount"> ${{motorAmountYTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorYTDDetailShow" v-html="getmotorDetails(motorsYTD)">  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              color="basil"
              flat
              style="float:left; width:100%;"
            >
              <v-card-text>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">WTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorAndAccessoriesWTDDetailShow = !motorAndAccessoriesWTDDetailShow">
                      <div class="count greyy"> {{motorAndAccessoriesCountWTD}} </div>
                      <div class="amount"> ${{motorAndAccessoriesAmountWTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorAndAccessoriesWTDDetailShow" v-html="getmotorDetails(motorAndAccessoriesWTD)">  </div>
                </v-flex>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">MTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorAndAccessoriesMTDDetailShow = !motorAndAccessoriesMTDDetailShow">
                      <div class="count greyy"> {{motorAndAccessoriesCountMTD}} </div>
                      <div class="amount"> ${{motorAndAccessoriesAmountMTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorAndAccessoriesMTDDetailShow" v-html="getmotorDetails(motorAndAccessoriesMTD)">  </div>
                </v-flex>
                <v-flex w4 text-xs-center>
                  <h1 class="mb-3 greyy">YTD</h1>
                  <div class="circle">
                    <div justify-center align-center v-if="false">
                      <v-progress-circular
                      indeterminate
                      color="primary">
                      </v-progress-circular>
                    </div>
                    <div v-else class="pinkk" @click="motorAndAccessoriesYTDDetailShow = !motorAndAccessoriesYTDDetailShow">
                      <div class="count greyy"> {{motorAndAccessoriesCountYTD}} </div>
                      <div class="amount"> ${{motorAndAccessoriesAmountYTD}} </div>
                    </div>
                  </div>
                  <div class="details mt-5 greyy" v-if="motorAndAccessoriesYTDDetailShow" v-html="getmotorDetails(motorAndAccessoriesYTD)">  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ItemService from '@/services/ItemService'
import moment from 'moment'
export default {
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    showDashboard: false,
    motorCountWTD: 0,
    motorCountMTD: 0,
    motorCountYTD: 0,
    motorAmountWTD: 0,
    motorAmountMTD: 0,
    motorAmountYTD: 0,
    motorsWTD: [],
    motorsMTD: [],
    motorsYTD: [],
    accessoriesCountWTD: 0,
    accessoriesCountMTD: 0,
    accessoriesCountYTD: 0,
    accessoriesAmountWTD: 0,
    accessoriesAmountMTD: 0,
    accessoriesAmountYTD: 0,
    accessoriesWTD: [],
    accessoriesMTD: [],
    accessoriesYTD: [],
    motorAndAccessoriesCountWTD: 0,
    motorAndAccessoriesCountMTD: 0,
    motorAndAccessoriesCountYTD: 0,
    motorAndAccessoriesAmountWTD: 0,
    motorAndAccessoriesAmountMTD: 0,
    motorAndAccessoriesAmountYTD: 0,
    motorAndAccessoriesWTD: [],
    motorAndAccessoriesMTD: [],
    motorAndAccessoriesYTD: [],
    tab: null,
    motorWTDDetailShow: false,
    motorMTDDetailShow: false,
    motorYTDDetailShow: false,
    motorAndAccessoriesWTDDetailShow: false,
    motorAndAccessoriesMTDDetailShow: false,
    motorAndAccessoriesYTDDetailShow: false
  }),
  mounted () {
    if (this.loggedInUser.email === 'books@diyblinds.com.au') {
      this.showDashboard = false
    } else if (this.loggedInUser.position && ['manager'].includes(this.loggedInUser.position.role)) {
      this.showDashboard = true
    }
    this.getItemsWithMotors()
  },
  methods: {
    async getItemsWithMotors () {
      var curr = new Date() // get current date
      let response = await ItemService.getItemsWithMotors()
      let items = response.data.items
      let itemMotorsYear = items.filter(function (item) {
        return item.type !== 'Motor Accessories'
      })
      this.motorCountYTD = itemMotorsYear.length
      let itemsMonth = items.filter(function (item) {
        // return new Date(item.orderID.date).getTime() > new Date(`${curr.getFullYear()},${curr.getMonth() + 1},01`).getTime()
        return moment(item.orderID.date).format('YYYY-MM-DD') > moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      })
      let itemMotorsMonth = itemsMonth.filter(function (item) {
        return item.type !== 'Motor Accessories'
      })
      this.motorCountMTD = itemMotorsMonth.length

      var first = curr.getDate() - curr.getDay() // First day is the day of the month - the day of the week
      // var last = first + 6 // last day is the first day + 6

      var firstday = new Date(curr.setDate(first)).getTime()
      // var lastday = new Date(curr.setDate(last)).getTime()
      let itemsWeek = items.filter(function (item) {
        return new Date(item.orderID.date).getTime() > firstday
      })
      let itemMotorsWeek = itemsWeek.filter(function (item) {
        return item.type !== 'Motor Accessories'
      })
      this.motorCountWTD = itemMotorsWeek.length
      let doubleChainOrMotor = ['LR', 'LLR', 'LRR']

      this.motorPriceWTD = 0
      this.accessoriesAmountWTD = 0
      this.accessoriesCountWTD = 0
      this.motorAndAccessoriesPriceWTD = 0
      this.motorsWTD = []
      // let remoteWTD = []
      // let chargerWTD = []
      // let automationWTD = []
      for (let index = 0; index < itemsWeek.length; index++) {
        const item = itemsWeek[index]
        if (item.variations && item.variations.remote && !['No Remote', 'Telis Pure 16 channel'].includes(item.variations.remote)) {
          item.variations.remote = this.getAccessoriesName(item.variations.remote)
          this.accessoriesWTD[item.variations.remote] = this.accessoriesWTD[item.variations.remote] ? this.accessoriesWTD[item.variations.remote] + 1 : 1
          this.accessoriesAmountWTD += await this.getAccessoriesPrice(item.variations.remote)
          this.accessoriesCountWTD += 1
          console.log(item.variations)
        }
        if (item.variations && item.variations.charger && item.variations.charger !== 'No Charger' && item.variations.charger !== 'Yes') {
          item.variations.charger = this.getAccessoriesName(item.variations.charger)
          this.accessoriesWTD[item.variations.charger] = this.accessoriesWTD[item.variations.charger] ? this.accessoriesWTD[item.variations.charger] + 1 : 1
          this.accessoriesAmountWTD += await this.getAccessoriesPrice(item.variations.charger)
          this.accessoriesCountWTD += 1
          console.log(item.variations)
        }
        if (item.variations && item.variations.automation && item.variations.automation !== 'None') {
          item.variations.automation = this.getAccessoriesName(item.variations.automation)
          this.accessoriesWTD[item.variations.automation] = this.accessoriesWTD[item.variations.automation] ? this.accessoriesWTD[item.variations.automation] + 1 : 1
          this.accessoriesAmountWTD += await this.getAccessoriesPrice(item.variations.automation)
          this.accessoriesCountWTD += 1
          console.log(item.variations)
        }
        if (item.variations) {
          let motorOption = item.variations.motorOption
          if ((item.variations.driveControl === 'Motor' && !item.variations.motorOption) || item.variations.trackType === 'Motorised' || item.variations.trackType === 'Glydea') {
            motorOption = item.variations.motor
          }
          motorOption = this.getMotorName(motorOption)
          let price = await this.getMotorPrice(motorOption, item.width)
          this.motorsWTD[motorOption] = this.motorsWTD[motorOption] ? this.motorsWTD[motorOption] + 1 : 1
          this.motorAmountWTD += price
          // for Double Roller Blinds need to add motor twice so added one more
          if (item.type === 'Double Roller Blind') {
            this.motorsWTD[motorOption] = this.motorsWTD[motorOption] + 1
            this.motorAmountWTD += price
            this.motorCountWTD += 1
          }
          // for Linked Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor twice so added one more
          if (item.type === 'Linked Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
            this.motorsWTD[motorOption] = this.motorsWTD[motorOption] + 1
            this.motorAmountWTD += price
            this.motorCountWTD += 1
          }
          // for Linked Double Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor four times else twice
          if (item.type === 'Linked Double Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
            this.motorsWTD[motorOption] = this.motorsWTD[motorOption] + 3
            this.motorAmountWTD += price * 3
            this.motorCountWTD += 3
          }
        } else {
          if (item.type === 'Motor Accessories') {
            console.log(item.variations)
            item.name = this.getAccessoriesName(item.name)
            this.accessoriesWTD[item.name] = this.accessoriesWTD[item.name] ? this.accessoriesWTD[item.name] + 1 : 1
            this.accessoriesAmountWTD += await this.getAccessoriesPrice(item.name)
            this.accessoriesCountWTD += 1
          }
        }
      }
      this.motorPriceMTD = 0
      this.accessoriesAmountMTD = 0
      this.accessoriesCountMTD = 0
      this.motorAndAccessoriesPriceMTD = 0
      this.motorsMTD = []
      // let remoteMTD = []
      // let chargerMTD = []
      // let automationMTD = []
      for (let index = 0; index < itemsMonth.length; index++) {
        const item = itemsMonth[index]
        if (item.variations && item.variations.remote && !['No Remote', 'Telis Pure 16 channel'].includes(item.variations.remote)) {
          item.variations.remote = this.getAccessoriesName(item.variations.remote)
          this.accessoriesMTD[item.variations.remote] = this.accessoriesMTD[item.variations.remote] ? this.accessoriesMTD[item.variations.remote] + 1 : 1
          this.accessoriesAmountMTD += await this.getAccessoriesPrice(item.variations.remote)
          this.accessoriesCountMTD += 1
        }
        if (item.variations && item.variations.charger && item.variations.charger !== 'No Charger' && item.variations.charger !== 'Yes') {
          item.variations.charger = this.getAccessoriesName(item.variations.charger)
          this.accessoriesMTD[item.variations.charger] = this.accessoriesMTD[item.variations.charger] ? this.accessoriesMTD[item.variations.charger] + 1 : 1
          this.accessoriesAmountMTD += await this.getAccessoriesPrice(item.variations.charger)
          this.accessoriesCountMTD += 1
        }
        if (item.variations && item.variations.automation && item.variations.automation !== 'None') {
          item.variations.automation = this.getAccessoriesName(item.variations.automation)
          this.accessoriesMTD[item.variations.automation] = this.accessoriesMTD[item.variations.automation] ? this.accessoriesMTD[item.variations.automation] + 1 : 1
          this.accessoriesAmountMTD += await this.getAccessoriesPrice(item.variations.automation)
          this.accessoriesCountMTD += 1
        }
        if (item.variations) {
          let motorOption = item.variations.motorOption
          if ((item.variations.driveControl === 'Motor' && !item.variations.motorOption) || item.variations.trackType === 'Motorised' || item.variations.trackType === 'Glydea') {
            motorOption = item.variations.motor
          }
          motorOption = this.getMotorName(motorOption)
          let price = await this.getMotorPrice(motorOption, item.width)
          this.motorsMTD[motorOption] = this.motorsMTD[motorOption] ? this.motorsMTD[motorOption] + 1 : 1
          this.motorAmountMTD += price
          // for Double Roller Blinds need to add motor twice so added one more
          if (item.type === 'Double Roller Blind') {
            this.motorsMTD[motorOption] = this.motorsMTD[motorOption] + 1
            this.motorAmountMTD += price
            this.motorCountMTD += 1
          }
          // for Linked Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor twice so added one more
          if (item.type === 'Linked Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
            this.motorsMTD[motorOption] = this.motorsMTD[motorOption] + 1
            this.motorAmountMTD += price
            this.motorCountMTD += 1
          }
          // for Linked Double Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor four times else twice
          if (item.type === 'Linked Double Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
            this.motorsMTD[motorOption] = this.motorsMTD[motorOption] + 3
            this.motorAmountMTD += price * 3
            this.motorCountMTD += 3
          }
        } else {
          if (item.type === 'Motor Accessories') {
            item.name = this.getAccessoriesName(item.name)
            this.accessoriesMTD[item.name] = this.accessoriesMTD[item.name] ? this.accessoriesMTD[item.name] + 1 : 1
            this.accessoriesAmountMTD += await this.getAccessoriesPrice(item.name)
            this.accessoriesCountMTD += 1
          }
        }
      }
      // console.log(this.motorsMTD[motorOption])
      this.motorPriceYTD = 0
      this.accessoriesAmountYTD = 0
      this.accessoriesCountYTD = 0
      this.motorAndAccessoriesPriceYTD = 0
      this.motorsYTD = []
      // let remoteYTD = []
      // let chargerYTD = []
      // let automationYTD = []
      for (let index = 0; index < items.length; index++) {
        const item = items[index]
        if (item.variations && item.variations.remote && !['No Remote', 'Telis Pure 16 channel'].includes(item.variations.remote)) {
          item.variations.remote = this.getAccessoriesName(item.variations.remote)
          this.accessoriesYTD[item.variations.remote] = this.accessoriesYTD[item.variations.remote] ? this.accessoriesYTD[item.variations.remote] + 1 : 1
          this.accessoriesAmountYTD += await this.getAccessoriesPrice(item.variations.remote)
          this.accessoriesCountYTD += 1
        }
        if (item.variations && item.variations.charger && item.variations.charger !== 'No Charger' && item.variations.charger !== 'Yes') {
          item.variations.charger = this.getAccessoriesName(item.variations.charger)
          this.accessoriesYTD[item.variations.charger] = this.accessoriesYTD[item.variations.charger] ? this.accessoriesYTD[item.variations.charger] + 1 : 1
          this.accessoriesAmountYTD += await this.getAccessoriesPrice(item.variations.charger)
          this.accessoriesCountYTD += 1
        }
        if (item.variations && item.variations.automation && item.variations.automation !== 'None') {
          item.variations.automation = this.getAccessoriesName(item.variations.automation)
          this.accessoriesYTD[item.variations.automation] = this.accessoriesYTD[item.variations.automation] ? this.accessoriesYTD[item.variations.automation] + 1 : 1
          this.accessoriesAmountYTD += await this.getAccessoriesPrice(item.variations.automation)
          this.accessoriesCountYTD += 1
        }

        if (item.variations) {
          let motorOption = item.variations.motorOption
          if ((item.variations.driveControl === 'Motor' && !item.variations.motorOption) || item.variations.trackType === 'Motorised' || item.variations.trackType === 'Glydea') {
            motorOption = item.variations.motor
          }
          let price = 0
          if (motorOption && motorOption !== '') {
            motorOption = this.getMotorName(motorOption)
            price = await this.getMotorPrice(motorOption, item.width)
            this.motorsYTD[motorOption] = this.motorsYTD[motorOption] ? this.motorsYTD[motorOption] + 1 : 1
            this.motorAmountYTD += price
            // for Double Roller Blinds need to add motor twice so added one more
            if (item.type === 'Double Roller Blind') {
              this.motorsYTD[motorOption] = this.motorsYTD[motorOption] + 1
              this.motorAmountYTD += price
              this.motorCountYTD += 1
              // console.log(item.type)
            }
            // for Linked Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor twice so added one more
            if (item.type === 'Linked Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
              this.motorsYTD[motorOption] = this.motorsYTD[motorOption] + 1
              this.motorAmountYTD += price
              this.motorCountYTD += 1
            }
            // for Linked Double Roller Blinds if easyLink is in ['LR','LLR','LRR'] then need to add motor four times else twice
            if (item.type === 'Linked Double Roller Blind' && doubleChainOrMotor.includes(item.easyLink)) {
              this.motorsYTD[motorOption] = this.motorsYTD[motorOption] + 3
              this.motorAmountYTD += price * 3
              this.motorCountYTD += 3
            }
          }
        } else {
          if (item.type === 'Motor Accessories') {
            item.name = this.getAccessoriesName(item.name)
            this.accessoriesYTD[item.name] = this.accessoriesYTD[item.name] ? this.accessoriesYTD[item.name] + 1 : 1
            this.accessoriesAmountYTD += await this.getAccessoriesPrice(item.name)
            this.accessoriesCountYTD += 1
          }
        }
      }
      this.motorAndAccessoriesCountWTD = this.motorCountWTD + this.accessoriesCountWTD
      this.motorAndAccessoriesCountMTD = this.motorCountMTD + this.accessoriesCountMTD
      this.motorAndAccessoriesCountYTD = this.motorCountYTD + this.accessoriesCountYTD
      this.motorAndAccessoriesAmountWTD = this.motorAmountWTD + this.accessoriesAmountWTD
      this.motorAndAccessoriesAmountMTD = this.motorAmountMTD + this.accessoriesAmountMTD
      this.motorAndAccessoriesAmountYTD = this.motorAmountYTD + this.accessoriesAmountYTD
      // this.accessoriesWTD = {...remoteWTD, ...chargerWTD, ...automationWTD}
      // this.accessoriesMTD = {...remoteMTD, ...chargerMTD, ...automationMTD}
      // this.accessoriesYTD = {...remoteYTD, ...chargerYTD, ...automationYTD}

      // console.log(items)
      // console.log(remoteYTD)
      // console.log(chargerYTD)
      // console.log(automationYTD)
      let motorsWTD = this.motorsWTD
      let motorsMTD = this.motorsMTD
      let motorsYTD = this.motorsYTD
      let accessoriesWTD = this.accessoriesWTD
      let accessoriesMTD = this.accessoriesMTD
      let accessoriesYTD = this.accessoriesYTD

      this.motorsWTD = this.sortArray(motorsWTD)
      this.motorsMTD = this.sortArray(motorsMTD)
      this.motorsYTD = this.sortArray(motorsYTD)
      this.motorAndAccessoriesWTD = this.sortArray({...motorsWTD, ...accessoriesWTD})
      this.motorAndAccessoriesMTD = this.sortArray({...motorsMTD, ...accessoriesMTD})
      this.motorAndAccessoriesYTD = this.sortArray({...motorsYTD, ...accessoriesYTD})
    },
    sortArray (array) {
      let sortable = []
      var maxData = array
      for (var value in maxData) {
        sortable.push([value, maxData[value]])
      }
      sortable.sort(function (a, b) {
        return b[1] - a[1]
      })
      return sortable
    },
    async getMotorPrice (motorOption, width) {
      motorOption = this.getMotorName(motorOption)
      switch (motorOption) {
        case 'Somfy Altus 28 - External Battery':
          return 210
          // break
        case 'Somfy Sonesse 30 2.0nm':
          return 295
          // break
        case 'Somfy Altus 28 1.5nm':
          return 210
          // break
        case 'Somfy Altus 40mm RTS':
          return 265
          // break
        case 'Somfy LS 40':
          return 250
          // break
        case 'Somfy Sonesse WT 40':
          return 340
          // break
        case 'Somfy Sonesse RTS 40mm':
          return 380
          // break
        case 'Irismo 45 WireFree RTS':
        case 'Somfy Irismo':
        case 'Glydea 35e RTS':
        case 'Somfy Glydea':
          if (width <= 2000) {
            return 1105
          } else if (width <= 3000) {
            return 1197
          } else if (width <= 4000) {
            return 1283
          } else if (width <= 5000) {
            return 1400
          } else if (width < 7000) {
            return 1497
          }
          break
        default:
          console.log(motorOption)
          break
      }
    },
    getMotorName (motorOption) {
      let motor = ''
      switch (motorOption) {
        case 'Somfy Altus 28 - External Battery ($210)':
        case 'Somfy Altus 28 - External Battery':
          motor = 'Somfy Altus 28 - External Battery'
          break
        case 'Somfy Sonesse 30 2.0nm ($295)':
        case 'Somfy Sonesse 30 2.0nm':
          motor = 'Somfy Sonesse 30 2.0nm'
          break
        case 'Somfy Altus 28 1.5nm ($210)':
        case 'Somfy Altus 28 1.5nm':
          motor = 'Somfy Altus 28 1.5nm'
          break
        case 'Somfy Altus 40mm RTS ($265)':
        case 'Somfy Altus 40mm RTS':
          motor = 'Somfy Altus 40mm RTS'
          break
        case 'Somfy LS 40 ($250)':
        case 'Somfy LS 40':
          motor = 'Somfy LS 40'
          break
        case 'Somfy Sonesse WT 40 ($340)':
        case 'Somfy Sonesse WT 40':
          motor = 'Somfy Sonesse WT 40'
          break
        case 'Somfy Sonesse RTS 40mm ($380)':
        case 'Somfy Sonesse RTS 40mm':
          motor = 'Somfy Sonesse RTS 40mm'
          break
        case 'Irismo 45 WireFree RTS':
        case 'Somfy Irismo':
          motor = 'Irismo 45 WireFree RTS'
          break
        case 'Glydea 35e RTS':
        case 'Somfy Glydea':
          motor = 'Glydea 35e RTS'
          break
        default:
          motor = ''
          console.log(motorOption)
          break
      }
      return motor
    },
    getmotorDetails (motors) {
      let html = ''
      for (let prop in motors) {
        html += `
          <div style="width:100%; float: left;" class="mb-2">
            <div class="left">${motors[prop][0]}</div>
            <div class="right pinkk"><b>${motors[prop][1]}</b></div>
          </div>
        `
      }
      return html
    },
    async getAccessoriesPrice (motorAccessories) {
      // motorAccessories = this.getAccessoriesName(motorAccessories)
      switch (motorAccessories) {
        // motors
        case 'Somfy Sonesse 30 2.0nm':
          return 295
          // break
        case 'Somfy Altus 28 1.5nm':
          return 210
          // break

        // remotes
        case 'Situo Pure 1 channel Remote':
          return 65
          // break
        case 'Situo Pure 5 channel Remote':
          return 100
          // break

        // chargers
        case 'Somfy Motor Charger':
          return 25
          // break
        case 'Irismo 45 Li-ion Charger':
          return 70
          // break

        // automation
        case 'Somfy Connexoon':
          return 299
          // break
        default:
          console.log(motorAccessories)
          break
      }
    },
    getAccessoriesName (motorAccessories) {
      let accessories = ''
      switch (motorAccessories) {
        case 'Somfy Sonesse 30 2.0nm ($295)':
        case 'Somfy Sonesse 30 2.0nm':
          accessories = 'Somfy Sonesse 30 2.0nm'
          break
        case 'Somfy Altus 28 1.5nm ($210)':
        case 'Somfy Altus 28 1.5nm':
          accessories = 'Somfy Altus 28 1.5nm'
          break
        case 'Situ Pure 1 channel':
        case 'Somfy Situo 1 channel':
        case 'Situo Pure 1 channel':
        case 'Situo Pure 1 channel Remote':
          accessories = 'Situo Pure 1 channel Remote'
          break
        case 'Situ Pure 5 channel':
        case 'Somfy Situo 5 channel':
        case 'Situo Pure 5 channel':
        case 'Situo Pure 5 Channel':
        case 'Situo Pure 5 channel Remote':
          accessories = 'Situo Pure 5 channel Remote'
          break
        case 'Somfy Motor Charger':
          accessories = 'Somfy Motor Charger'
          break
        case 'Irismo 45 Li-ion Charger':
          accessories = 'Irismo 45 Li-ion Charger'
          break
        case 'Somfy Connexoon':
          accessories = 'Somfy Connexoon'
          break
        default:
          accessories = ''
          console.log(motorAccessories)
          break
      }
      return accessories
    },
    getAccessoriesDetails (accessories) {
      let html = ''
      for (let prop in accessories) {
        html += `
          <div style="width:100%; float: left;" class="mb-2">
            <div class="left">${accessories[prop][0]}</div>
            <div class="right pinkk"><b>${accessories[prop][1]}</b></div>
          </div>
        `
      }
      return html
    }
  },
  components: {}
}
</script>

<style scoped>
.circle {
  width: 300px;
  height: 300px;
  border: 3px solid #565e6f;
  margin: 0 auto;
  border-radius: 50%;
  font-size: 72px;
  font-weight: bold;
  color: #565e6f;
  line-height: 100px;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
}
.amount {
  font-size: 36px;
}
.border-right2 {
  border-right: 2px solid #ddd;
}
.pinkk {
  color: #ea4d76;
}
.width300 {
  width: 300px;
}
.responsive-table {
  display: block;
  width: 100%;
  overflow-x: auto;
}
td {
  vertical-align: top !important;
}
.mHeight {
  min-height: 550px;
  max-height: 550px;
  overflow: auto;
}
.greyy {
  color: #565e6f;
}
.greenn {
  color:#19ec81;
}
.cursor-pointer {
  cursor: pointer;
}
.margin-auto {
  margin: 0 auto;
}
.w6 {
  width: 50%;
  float: left;
}
.w4 {
  width: 33.33%;
  float: left;
}
.details {
  font-size: 16px;
}
@media screen and (max-width: 661px) {
  .w4{
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MotorisationDashboard.vue